import "./documentRow.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { qilloIconMap } from "../../utils/iconMapping";
import newRequest from "../../utils/newRequest";
import { ScaleLoader } from "react-spinners";
import { GoHomeFill } from "react-icons/go";

const FavMenuWidget = () => {
    const { t } = useTranslation();
    const { currentTheme } = useSelector((state) => state.theme);
    const { currentUser } = useSelector((state) => state.user);
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const [favMenus, setFavMenus] = useState([]);
    const [selectedFavMenu, setSelectedFavMenu] = useState(null);

    const fetchFavouriteMenus = async () => {
        try {
            const res = await newRequest.get("/adUserRole/fav");
            setFavMenus(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchFavouriteMenus();
    }, [currentUser]);

    return (
        <motion.div
            className="document-row"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
        >
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
                </div>
            ) : (
                favMenus?.length > 0 ?
                    <div className="fav-menu-wrapper">
                        {favMenus?.map((menu, index) => {
                            const IconComponent = qilloIconMap[menu?.menu_icon] || GoHomeFill;
                            return (
                                <div key={menu?._id}
                                    className={`${selectedFavMenu?._id === menu?._id ? "sub-menu-item current" : "sub-menu-item"}`}
                                    onClick={async () => {
                                        try {
                                            setSelectedFavMenu(menu);
                                            const path = `/${menu?.menu_function?.replace(/^\/+/, "")}`;
                                            navigate(path, {
                                                replace: true,
                                                state: {
                                                    showBack: "Y",
                                                    menuDocid: menu?._id,
                                                    favMenu: "Y"
                                                },
                                            });
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}>
                                    <IconComponent className="sub-menu-icon" />
                                    <div className="sub-menu-content">
                                        <div className="sub-menu-name">{menu?.menu_name}</div>
                                        <div className="sub-menu-description">{menu?.menu_function}</div>
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                                        <span className="sub-title">{index + 1}</span>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    :
                    <div className="no-content-wrapper">
                        <span className="main-title">Your shortcut menus will appear here. To add, go to profile screen</span>
                    </div>
            )}
        </motion.div>
    );
};

export default FavMenuWidget